// extracted by mini-css-extract-plugin
module.exports = {"highlightAlert":"styles-module__highlightAlert___2xjQ3"};